import { compose } from "@reduxjs/toolkit";
import { Col, Image, Row, Skeleton, Tag, Typography } from "antd";
import dayjs from 'dayjs';
import React from "react";
import { Link } from "react-router-dom";
import { NJVButton } from "../../components/core-component";
import { SvgArrowLeftFilled } from "../../components/custom-svgIcon";
import { TitleLevel4 } from "../../components/general-component";
import Theme, { Colors } from "../../components/theme";
import Api from "../../network/api";
import { HTTP_METHOD } from "../../network/httpMethod";
import { MEDIA_TYPE } from "../../network/mediaType";
import { ApiHandler } from "../../network/network-manager";
import withRouter from "../../network/with-router";
import CustomPath from "../../routes/custom-path";

const { Paragraph } = Typography;

const annocementIcon = require('../../asset/annocement.png');
class NotificationDetail extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            notificationId: props.location.state?.data || null,
            data: {},
            isDataFetching: false
        }
    }

    componentDidMount = () => {
        this.fetchData()
    }

    fetchData = async () => {
        this.setState({
            isDataFetching: true
        })
        try {
            // let response = await ApiHandler(Api.notification_history, HTTP_METHOD.GET, MEDIA_TYPE.JSON ,null,this.state.notificationId)
            let response = await ApiHandler({ url: Api.notification_history, method: HTTP_METHOD.GET, mediaType: MEDIA_TYPE.JSON, specificId: this.state.notificationId })
            if (response) {
                if (response.createdDate != null) {
                    const createdDate = dayjs(response.createdDate, 'YYYY-MM-DD HH:mm A');
                    if (createdDate) {
                        response = { ...response, 'createdDate': createdDate.format('MMM DD, YYYY hh:mm A') }
                    }
                }
                this.setState({
                    data: response
                })
            }

        } catch (error) {
        }
        this.setState({
            isDataFetching: false
        })
    }

    render() {
        const { data, isDataFetching } = this.state

        return (
            <>
                <Row>

                    <Col lg={6} md={6} xs={1} sm={1} />
                    <Col lg={12} md={12} xs={22} sm={22}>
                        <Link to={CustomPath.notification} state={{ route: data.notificationType }}>
                            <NJVButton type="primary"
                                style={{
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center'
                                }}
                                buttonprimary={Theme.colors.primary}
                            >
                                <SvgArrowLeftFilled width={20} height={20} color={'#fff'} /><span style={{ marginLeft: 5 }}>Back</span>
                            </NJVButton>
                        </Link>

                        {
                            isDataFetching ?
                                <Skeleton active />
                                :
                                <>
                                    {
                                        data.notificationType === 'ANNOUNCEMENT' ?
                                            <div style={{ textAlign: 'center', marginBottom: 20 }}>
                                                <Image
                                                    style={{
                                                        marginTop: 5,
                                                        cursor: 'pointer',
                                                        backgroundColor: Colors.primary,
                                                        borderRadius: 100
                                                    }}
                                                    preview={false}
                                                    src={annocementIcon}
                                                    width={100}
                                                    height={100}
                                                />
                                            </div>
                                            :
                                            <></>
                                    }
                                    <TitleLevel4 label={data.title} />
                                    <Paragraph>
                                        <Tag>

                                            {data.createdDate}
                                        </Tag>
                                    </Paragraph>
                                    {
                                        data.photoUrl ?
                                            <Paragraph>
                                                <Image
                                                    style={{
                                                        marginTop: 5,
                                                        borderRadius: 9,
                                                        cursor: 'pointer'
                                                    }}
                                                    preview={false}
                                                    src={data.photoUrl}
                                                    width={'100%'}
                                                />
                                            </Paragraph>
                                            :
                                            <></>
                                    }
                                    <Paragraph>
                                        <pre style={{ border: 'none', backgroundColor: 'transparent' }}>
                                            {data.content}
                                        </pre>
                                    </Paragraph>
                                </>
                        }
                    </Col>
                </Row>
            </>
        )
    }
}

export default compose(withRouter)(NotificationDetail)